import { Injectable } from '@angular/core';
import { Logger } from '@nsalaun/ng-logger';
import { Subject, of } from 'rxjs';
import { aagSessionStorageConstants } from '../constants/ui-constants';
import { StudentSignInResponse } from '../model/student';
// import { AuthService } from './auth.service'; // Disabled for development
import { ServiceStatus } from '../model/service.status';
import { SigninStatus } from '../model/signin.status';
import { aagPersistentStorage } from './sessionmanager.service';
import { StudentService } from './student.service';
import { WorkgroupService } from './workgroup.service';

@Injectable({
  providedIn: 'root',
})
export class SignInProfileService {
  private firstName: string = '';

  /**
   * The backing state used by the state$ observable, this keeps track of current item in the application. When a
   * value is set or removed, .next() needs to be called on state$ to propagate that change to all subscribers
   */

  private signinUserState: SigninStatus = SigninStatus.WAIT;

  /**
   * An Subject observable state will published values that were emitted after the subscription.   No past history is provided
   */
  public signinUserState$ = new Subject<SigninStatus>();

  constructor(
    // private authService: AuthService, // Disabled for development
    private persistenceSvc: aagPersistentStorage,
    private studentService: StudentService,
    private logger: Logger,
    private workgroupService: WorkgroupService
  ) {
    logger.debug('signinService(DEBUG) CONSTRUCTOR initialize.................' + new Date().toLocaleString());
  }

  private processSigninProfile(signInResponse: StudentSignInResponse) {
    console.log('SignInProfileService: Processing signin response', { 
      status: signInResponse.status,
      student: signInResponse.student,
      ServiceStatus: ServiceStatus 
    });

    switch (signInResponse.status) {
      case ServiceStatus.SUCCESS:
        console.log('SignInProfileService: SUCCESS - storing student data', signInResponse.student);
        this.persistenceSvc.write(aagSessionStorageConstants.SESSIONSTUDENT, signInResponse.student);
        this.signinUserState = SigninStatus.AUTHORIZED;
        break;
      case ServiceStatus.DOES_NOT_EXIST:
        console.log('SignInProfileService: DOES_NOT_EXIST - student not found');
        if (!this.firstName) this.firstName = signInResponse.student.firstName;
        this.persistenceSvc.write(aagSessionStorageConstants.SSOFIRSTNAME, this.firstName);
        this.signinUserState = SigninStatus.NOTAUTHORIZED;
        break;
      default:
        console.log('SignInProfileService: SYSTEM_FAILURE - unknown status', signInResponse.status);
        this.signinUserState = SigninStatus.SYSTEM_FAILURE;
        this.resetSessionState();
    }

    console.log('SignInProfileService: Setting signin state to', SigninStatus[this.signinUserState]);
    this.signinUserState$.next(this.signinUserState);
  }

  SSOlogIn(token: string) {
    this.firstName = '';
    let positionId: string = this.workgroupService.getCurrentJobPositionId();

    // this.logger.debug('signinServiceZ(DEBUG) SSOlogIn start....');
    this.studentService.ssoSignIn(token, positionId).subscribe((signInResponse) => {
      // this.logger.debug('signinServiceZ(DEBUG) SSOlogIn subscribe.................' + new Date().toLocaleString());

      this.processSigninProfile(signInResponse);
    });
  }

  SharepointlogIn(firstName, lastName, dateOfBirth) {
    this.firstName = firstName;
    let positionId: string = this.workgroupService.getCurrentJobPositionId();

    console.log('SignInProfileService: SharepointlogIn called with', { 
      firstName, 
      lastName, 
      dateOfBirth, 
      positionId,
      hostname: window.location.hostname 
    });

    this.studentService.signIn(firstName, lastName, dateOfBirth, positionId).subscribe((signInResponse) => {
      console.log('SignInProfileService: Student service response received', signInResponse);
      this.processSigninProfile(signInResponse);
    }, error => {
      console.error('SignInProfileService: Student service error', error);
      this.signinUserState = SigninStatus.SYSTEM_FAILURE;
      this.signinUserState$.next(this.signinUserState);
    });
  }

  isResetSessionRequested(): boolean {
    let isReset: boolean = false;
    let detectedReset = this.persistenceSvc.read(aagSessionStorageConstants.SESSSIONRESET);
    if (detectedReset) {
      // console.log('SignInProfileService......................reset requested');
      isReset = true;
    }
    return isReset;
  }

  resetSessionState() {
    let preserveSessionKeys = new Map<string, any>();
    let sessionKeys = new Map<string, any>();

    sessionKeys = this.persistenceSvc.readall();
    for (let [key, value] of sessionKeys) {
      if (key.startsWith('PERSIST')) {
        // console.log('SignInProfileService PRESERVE READ DATA.... key: ' + key + ' = ' + value);
        preserveSessionKeys.set(key, value);
      }
    }

    //Clear data
    // Commented out for development - auth service disabled
    // this.authService.logoff();
    this.persistenceSvc.clear();

    //Set initial state items
    //this.persistenceSvc.write(aagSessionStorageConstants.SSOISAUTHORIZED, 'false');
    for (let [key, value] of preserveSessionKeys) {
      // console.log('SignInProfileService PRESERVE SET DATA.... key: ' + key + ' = ' + value);
      this.persistenceSvc.write(key, value);
    }
    this.signinUserState = SigninStatus.WAIT;
  }

  // setAuthorization(auth: boolean): SigninStatus {
  //   // if (auth) {
  //   //   this.persistenceSvc.write(aagSessionStorageConstants.SSOISAUTHORIZED, 'true');
  //   //   return SigninStatus.AUTHORIZED;
  //   // } else {
  //   //   this.persistenceSvc.write(aagSessionStorageConstants.SSOISAUTHORIZED, 'false');
  //   //   return SigninStatus.NOTAUTHORIZED;
  //   // }

  //   this.signinUserState = auth ? SigninStatus.AUTHORIZED : SigninStatus.NOTAUTHORIZED;
  //   return this.signinUserState;
  // }

  //Overloading TypeScript Functions
  setAuthorization(auth: boolean): SigninStatus;
  setAuthorization(auth: SigninStatus);
  setAuthorization(auth: boolean | SigninStatus): SigninStatus {
    // console.log('type detected: ' + typeof auth);
    if (auth && typeof auth === 'boolean') {
      this.signinUserState = auth ? SigninStatus.AUTHORIZED : SigninStatus.NOTAUTHORIZED;
    } else {
      this.signinUserState = auth as SigninStatus;
    }

    return this.signinUserState;
  }

  getSSOStudentProfile() {
    let data = this.persistenceSvc.read(aagSessionStorageConstants.SESSIONSTUDENT);
    return data;
  }

  getSSOIsAuthorizedOrNotDetected(): string {
    let data: string = '';
    let isAuthorizedCheck = this.getSSOIsAuthorized();

    if (isAuthorizedCheck != null && !isAuthorizedCheck) {
      data = 'check';
    }

    return data;
  }

  getSSOIsAuthorized(): boolean | null {
    let check: boolean = null;

    // let isAuthorizedCheck = this.persistenceSvc.read(aagSessionStorageConstants.SSOISAUTHORIZED);
    // if (isAuthorizedCheck) {
    //   data = isAuthorizedCheck === 'true';
    // }

    switch (this.signinUserState) {
      case SigninStatus.NOTAUTHORIZED:
        check = false;
        break;
      case SigninStatus.AUTHORIZED:
        check = true;
      default:
        break;
    }

    return check;
  }

  getSSOFirstName() {
    let detectedFirstName = this.persistenceSvc.read(aagSessionStorageConstants.SSOFIRSTNAME);

    let actualFirstName = detectedFirstName ? detectedFirstName : '';
    return actualFirstName;
  }

  getUserProfile() {
    console.log('SignInProfileService: getUserProfile called');
    const student = this.getSSOStudentProfile();
    
    if (student) {
      console.log('SignInProfileService: Returning user profile from session', student);
      return of({ person: student });
    } else {
      console.log('SignInProfileService: No student profile in session');
      return of(null);
    }
  }
}

// if( value ) {
// }
// will evaluate to true if value is not:

// null
// undefined
// NaN
// empty string ''
// 0
// false
// typescript includes javascript rules.
